// Models
import { TaskCreationSourceKind } from "../../../../service/graph-legacy/task/IGraphTaskCreationResource";
// Utilities
import moment from "moment";
/**
 * Publication source information for the task
 */ export class Publication {
    /**
     * Creates a new Publication instance from a given Graph service resource
     * @param resource The service model
     */ static fromGraphResource(resource) {
        return new Publication(resource.publicationId, resource.publishingTeamId, resource.publishingTeamName, resource.lastModifiedDateTime, resource.publishedToPlanId, /* publishableTaskId is not available on Graph API */ "");
    }
    /**
     * Method to serialize IPublication resource to IGraphTeamsPublicationInfoResource
     * @param resource IPublication resource
     */ static toGraphResource(resource) {
        return {
            creationSourceKind: TaskCreationSourceKind.Publication,
            publicationId: resource.id,
            publishingTeamId: resource.sourceTeamId,
            publishingTeamName: resource.sourceTeamName,
            lastModifiedDateTime: resource.lastModifiedTime.toISOString(),
            publishedToPlanId: resource.publishedToPlanId
        };
    }
    /**
     * Initialize an instance of Publication Source Information for a task
     * @param id Id of the publication
     * @param sourceTeamId Id of the team publishing the task
     * @param sourceTeamName Name of the team publishing the task
     * @param dateString The date at which the publication was most recently updated
     * @param publishedToPlanId Id of the plan this task was published to
     * @param publishableTaskId Id of the publishing template of the task
     */ constructor(id, sourceTeamId, sourceTeamName, dateString, publishedToPlanId, publishableTaskId){
        this.id = id;
        this.sourceTeamId = sourceTeamId;
        this.sourceTeamName = sourceTeamName;
        this.lastModifiedTime = moment(dateString);
        this.publishedToPlanId = publishedToPlanId;
        this.publishableTaskId = publishableTaskId;
    }
}
